module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-md-3cf96fcf.jpg";